import React from 'react'

import { twMerge } from 'tailwind-merge'

interface SectionDescriptionProps {
  children?: React.ReactNode
  description?: string
  className?: string
}

const SectionDescription: React.FC<SectionDescriptionProps> = ({
  description,
  children,
  className,
}) =>
  children || description ? (
    <p className={twMerge('text-base text-balance', className)}>
      {children || description}
    </p>
  ) : null

export default SectionDescription
